import { GenericSlider, SliderConfig } from 'assets/js/slider.js';

class KachelSlider extends HTMLElement {
    constructor() {
        super();
        this.slider = null;
        this.videoAnimation = null;
        this.videoPauseTimer = null;
        this.MIN_PAUSE_DURATION = 1000;
        this.MAX_PAUSE_DURATION = 3000;
    }

    connectedCallback() {
        const config = new SliderConfig({
            listSelector: '.kachel-list',
            itemSelector: '.kachel-box',
            controlsSelector: '.navigation-controls',
            prevButtonSelector: '.prev',
            nextButtonSelector: '.next'
        });

        this.slider = new GenericSlider(this, config);
        this.slider.init();

        this.initVideoAnimation();
    }

    disconnectedCallback() {
        this.slider?.destroy();
        this.cleanupVideoAnimation();
    }

    initVideoAnimation() {
        this.videoAnimation = this.querySelector('.video-animation');

        if (!this.videoAnimation) {
            return;
        }

        this.videoAnimation.addEventListener('ended', this.handleVideoEnded.bind(this));

        if (this.videoAnimation.readyState >= 3) {
            this.playVideo();
        } else {
            this.videoAnimation.addEventListener('canplay', this.handleVideoCanPlay.bind(this));
        }
    }

    handleVideoCanPlay() {
        this.playVideo();
    }

    playVideo() {
        const playPromise = this.videoAnimation.play();
        if (playPromise !== undefined) {
            playPromise.catch(error => {
                console.log('Video autoplay prevented:', error);
            });
        }
    }

    handleVideoEnded() {
        const pauseDuration = Math.random() * (this.MAX_PAUSE_DURATION - this.MIN_PAUSE_DURATION) + this.MIN_PAUSE_DURATION;

        this.videoPauseTimer = setTimeout(() => {
            this.videoAnimation.currentTime = 0;
            const playPromise = this.videoAnimation.play();
            if (playPromise !== undefined) {
                playPromise.catch(error => {
                    console.log('Video replay failed:', error);
                });
            }
        }, pauseDuration);
    }

    cleanupVideoAnimation() {
        if (this.videoPauseTimer) {
            clearTimeout(this.videoPauseTimer);
        }
        if (this.videoAnimation) {
            this.videoAnimation.removeEventListener('ended', this.handleVideoEnded);
            this.videoAnimation.removeEventListener('canplay', this.handleVideoCanPlay);
        }
    }
}

if (!customElements.get("slider-kachel")) {
    customElements.define("slider-kachel", KachelSlider);
}
